<template>
  <tr>
    <td>{{ this.$props.room.name }}</td>
    <td>{{ this.$props.room.board_basis }}</td>
    <td>{{ this.$props.room.occupancy }}</td>
    <td>
      <input
        title="cost"
        id="tour_cost"
        class="room-table-price-input"
        type="number"
        placeholder="0.00"
        min="0"
        step="0.01"
        ref="cost"
        v-model="prices.cost"
        v-if="prices !== null"
        v-on:change="updatePrice($event)"
      />
    </td>
    <td>
      <input
        title="price"
        id="tour_price"
        class="room-table-price-input"
        type="number"
        placeholder="0.00"
        min="0"
        step="0.01"
        ref="price"
        v-model="prices.price"
        v-if="prices !== null"
        v-on:change="updatePrice($event)"
      />
    </td>
    <td>
      <input
        title="sale_price"
        id="tour_sale"
        class="room-table-price-input"
        type="number"
        placeholder="0.00"
        min="0"
        step="0.01"
        ref="sale_price"
        v-model="prices.sale_price"
        v-if="prices !== null"
        v-on:change="updatePrice($event)"
      />
    <td>
      <div class="spinner" v-bind:class="{active:spinner}"></div>
    </td>
  </tr>
</template>
<script>
  export default {
    name: 'PriceTableRow',
    props : {
      instanceId: null,
      room: null
    },
    data () {
      return {
        spinner: false,
        instance: null,
        prices: null,
      }
    },
    watch: {

    },
    created () {
      this.getPrices()
    },
    methods: {
      getPrices() {
        this.$store.dispatch('setLoadStatus')
        this.spinner = true
        fetch(this.$api + 'tours/instances/' + this.$props.instanceId + '/getprices', {
          method: 'POST',
          body: JSON.stringify({
            room_id : this.$props.room.id,
          }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          },
        })
        .then(res => res.json())
        .then(response => {
          this.prices = response.data
        })
        this.spinner = false
        this.$store.dispatch('setLoadStatus')
      },
      updatePrice(event) {
        this.spinner = true

        let body = {}
        body['tour_instance_id'] = this.$props.instanceId
        body['tour_room_id'] = this.$props.room.id
        body['price'] = this.prices.price
        body['cost'] = this.prices.cost
        body['sale_price'] = this.prices.sale_price

        fetch(this.$api + 'tours/instances/' + this.$props.instanceId + '/prices' , {
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.getPrices()
          this.errors = response.errors
          if(response.success) {
            this.$notify({
              type: 'success',
              title: event.target.title + ' updated'
            })
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
        })
        this.spinner = false
      }
    }
  }
</script>
